import { render } from "./SpaDayPayment.vue?vue&type=template&id=a29b24c0"
import script from "./SpaDayPayment.vue?vue&type=script&lang=js"
export * from "./SpaDayPayment.vue?vue&type=script&lang=js"

import "@/shared/css/payment.css?vue&type=style&index=0&lang=css&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__